module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic3.9b0f7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic3.png
// module id = 569
// module chunks = 1